App.SidebarOrderCardComponent = Em.Component.extend
  env: Em.inject.service('environment')

  classNames: ['sidebar-order-card']
  classNameBindings: [
    'order.status',
    'isSelected',
    'order.hasProblems:danger']

  isSelected: (->
    @get('selectedOrder') is @get('order')
  ).property('order', 'selectedOrder')

  translatedProblems: (->
    env = @get('env')
    @get('order.problems').map (p) =>
      env.translate("order.problems.#{p.checkpoint}")
  ).property('order.problems')

  showCourierName: false

  showAssignedCourierInOrderCard: (->
    courier = @get('order.courier')
    courier and localStorage.getItem('showAssignedCourierInOrderCard') == 'true'
  ).property('order.courier')

  # ###
  # # Скроллить до карточки заказа если она выбрана
  # ###
  # scrollIntoView: (->
  #   return unless @get('isSelected')

  #   $card      = @$()
  #   $container = $card.closest('.orders-list-block')

  #   top       = $card.get(0).offsetTop - $container.get(0).offsetTop
  #   eh        = $card.outerHeight()
  #   ch        = $container.outerHeight()
  #   scrollTop = $container.scrollTop()

  #   y1 = top - scrollTop
  #   y2 = y1 + eh

  #   unless Math.min(y1, y2) > 0
  #     $container.animate({ scrollTop: top }, 400)

  #   unless Math.max(y1, y2) < ch
  #     $container.animate({ scrollTop: top - ch + eh}, 400)

  # ).observes('isSelected').on('didInsertElement')

  # didInsertElement: ->
  #   $card      = @$()
  #   $container = $card.closest('.orders-list-block')
  #   # $container.on 'scroll', @scrollIntoView.bind(@)

  click: ->
    @sendAction 'onOrderSelected', @get('order')

  orderStatusName: (->

    {
      pending   : Em.I18n.t 'order.status.pending'
      confirm   : Em.I18n.t 'order.status.confirm'
      preparing : Em.I18n.t 'order.status.preparing'
      prepared  : Em.I18n.t 'order.status.prepared'
      delivery  : Em.I18n.t 'order.status.delivery'
      complete  : Em.I18n.t 'order.status.complete'
      undo      : Em.I18n.t 'order.status.undo'
    }[@get('order.status')]

  ).property('order.status')

  deliveryAt: (->
    now      = moment()
    tomorrow = moment(now).add(1, 'days')

    delivery = moment(new Date(@get('order.delivery_at'))).tz(@get('order.timezone'))

    day  = ''
    if delivery.isSame(now, 'day')
      day = @get('env').translate('date.today')
    else if delivery.isSame(tomorrow, 'day')
      day = @get('env').translate('date.tomorrow')
    else
      day = delivery.format('D MMMM')

    time = delivery.format('H:mm')

    "#{day} #{@get('env').translate('date.by')} #{time}"
  ).property('order.delivery_at')